import SpotlightPromoBannerV2 from './SpotlightPromoBannerV2'

export default SpotlightPromoBannerV2
// eslint-disable-next-line import/export
export * from './SpotlightPromoBannerV2'
